import React from "react";
import SelectField from "./SelectField";
import type { ColSize } from "./TextField";

interface Props {
  name: string;
  label?: string;
  col?: ColSize;
  help?: string;
  onChange?: (value: string) => void;
}

export default function CurrencyField(props: Props) {
  return (
    <SelectField
      label={props.label || "Currency"}
      name={props.name}
      col={props.col}
      help={props.help}
      onChange={props.onChange}
    >
      <option value="">None Selected</option>
      <option>AUD</option>
      <option>GBP</option>
      <option>NZD</option>
      <option>SGD</option>
      <option>USD</option>
    </SelectField>
  );
}
